import { type TypeTableColumn } from '@thefarmersfront/kitchen';

import { formatDate } from '~/utils/date';

import { COLLECTING_SHIPPING_LABEL_STATUS_BADGE_COLOR, DATE_FORMAT } from '~/constants';

import { StatusBadge } from './deliveryAgencyTableCells';

import type { CollectingShippingLabel } from '~/types/delivery-agency.types';

const getDeliveryAgencyCollectingShippingLabelsColumnDefs = () => {
  const columnDefs: TypeTableColumn<CollectingShippingLabel>[] = [
    {
      accessorKey: 'shippingLabelNumber',
      header: '회수 운송장번호',
      size: 224,
    },
    {
      accessorKey: 'collectingShippingLabelStatus',
      header: '회수 운송장 상태',
      size: 120,
      cell: ({ row }) => {
        const value = row.original.collectingShippingLabelStatus;
        if (!value) return '-';

        return <StatusBadge value={value} colors={COLLECTING_SHIPPING_LABEL_STATUS_BADGE_COLOR} />;
      },
    },
    {
      accessorKey: 'statusUpdatedAt',
      header: '상태 마지막 업데이트 일시',
      size: 180,
      cell: ({ row }) => formatDate(row.original.statusUpdatedAt, DATE_FORMAT.DATE_TIME) ?? '-',
    },
    {
      accessorKey: 'failureReason',
      header: '회수 실패 사유',
      minSize: 170,
      cell: ({ row }) => row.original.failureReason?.description || '-',
      meta: { flex: true },
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyCollectingShippingLabelsColumnDefs;
